/* eslint-disable @next/next/no-img-element */
"use client";
import Image from "next/image";
// src/components/Slider.js
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useState, useEffect } from "react";
import Button from "../Button/page";
// const images = [
//   'image1.jpg',
//   'image2.jpg',
//   'image3.jpg',
//   // Add more image URLs as needed
// ];

const Slider = ({ path, content }) => {
    //   console.log("🚀 ~ Slider ~ content:", content.length)
    const [currentIndex, setCurrentIndex] = useState(0);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCurrentIndex((prevIndex) => {
    //             // console.log(`Previous Index: ${prevIndex}`);
    //             // console.log(`New Index: ${(prevIndex + 1) % content.length}`);
    //             return (prevIndex + 1) % content.length;
    //         });
    //     }, 3000);

    //     return () => clearInterval(interval);
    // }, [content]);

    // const goToSlide = (index) => {
    //     setCurrentIndex(index);
    // };

    // const goToPrevSlide = () => {
    //     setCurrentIndex(
    //         (prevIndex) => (prevIndex - 1 + content.length) % content.length
    //     );
    // };

    // const goToNextSlide = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex + 1) % content.length);
    // };

    // src/utils/utils.js
    const breakIntoLines = (text, maxFirstLineLength = 50) => {
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";

        for (let word of words) {
            if (
                currentLine.length + word.length + 1 <= maxFirstLineLength ||
                lines.length > 0
            ) {
                currentLine += (currentLine ? " " : "") + word;
            } else {
                lines.push(currentLine);
                currentLine = word;
            }
        }

        if (currentLine) {
            lines.push(currentLine);
        }

        // Adjust lines to ensure each subsequent line is shorter than the previous one
        for (let i = 1; i < lines.length; i++) {
            while (lines[i].length >= lines[i - 1].length) {
                let lastSpaceIndex = lines[i - 1].lastIndexOf(" ");
                if (lastSpaceIndex === -1) break;
                lines[i - 1] = lines[i - 1].slice(0, lastSpaceIndex);
            }
        }

        return lines;
    };

    return (
        <div className="relative w-full h-screen overflow-hidden">
            <Image
                src={`/assets/${path}/${content[0]?.bgImage}.jpg`}
                alt={content[0]?.alt}
                fill
                style={{
                    objectFit: "cover",
                }}
            />

            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-center text-white p-5 ">
                <h2 className="text-2xl lg:text-5xl !leading-snug font-semibold font-manrope flex flex-col justify-center items-center">
                    {breakIntoLines(content[0]?.title).map(
                        (line, lineIndex) => (
                            <span
                                key={lineIndex}
                                className="bg-black/70 my-1 px-2 rounded"
                            >
                                {line}
                            </span>
                        )
                    )}
                </h2>
                <div className="mt-10">
                    <Button className="btn-primary-purple">
                        {content[0]?.buttonName && content[0]?.buttonName}
                    </Button>
                </div>
            </div>
            {/* {content?.map((e, index) => (
                    <div
                        key={index}
                        className={`slide ${
                            index === currentIndex ? "active" : ""
                        }`}
                    >
                        <Image
                            src={`/assets/${path}/${e?.bgImage}.jpg`}
                            alt={e?.alt}
                            fill
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <div className="slide-content">
                            <h2 className="text-2xl lg:text-5xl !leading-snug font-semibold font-manrope text-white px-5">
                                {breakIntoLines(e?.title).map(
                                    (line, lineIndex) => (
                                        <span
                                            key={lineIndex}
                                            className="bg-black/70 my-10 px-2 rounded"
                                        >
                                            {line}
                                        </span>
                                    )
                                )}
                            </h2>
                            <div className="mt-10">
                                <Button className="btn-primary-purple">
                                    {e?.buttonName && e?.buttonName}
                                </Button>
                            </div>
                        </div>
                    </div>
                ))} */}

            {/* <div className="slider-controls">
                    <button className="arrow left" onClick={goToPrevSlide}>
                        <BsChevronLeft />
                    </button>
                    <div className="dots">
                        {content?.map((_, index) => (
                            <span
                                key={index}
                                className={`dot ${
                                    index === currentIndex ? "active" : ""
                                }`}
                                onClick={() => goToSlide(index)}
                            />
                        ))}
                        <button className="arrow right" onClick={goToNextSlide}>
                            <BsChevronRight />
                        </button>
                    </div>
                </div> */}
        </div>
    );
};

export default Slider;

// {    <style jsx>{`
//         .slider {
//           position: relative;
//           width: 100%;
//           height: 100vh;
//           display: flex;
//           transition: transform 0.5s ease;
//         }

//         .slide {
//           flex-shrink: 0;
//           width: 100%;
//           height: 100%;
//           background-size: cover;
//           background-position: center;
//           opacity: 0;
//           transition: opacity 0.5s ease;
//         }

//         .slide img {
//           object-fit: cover;
//           width: 100%;
//           height: 100%;
//         }

//         .slide.active {
//           opacity: 1;
//         }

//         .slide-content {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           text-align: center;
//           color: #fff;
//         }

//         .slider-controls {
//          position: absolute;
//           bottom: 20px;
//           left: 0;
//           right: 0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           width: 100%;
//           z-index: 1;
//         }

//         .slider-controls .arrow {
//           font-size: 2em;
//           color: #fff;
//           cursor: pointer;
//           background: none;
//           border: none;
//           padding: 0;
//           position: absolute;
//           top: 50%;
//         //   {/* transform: translateY(-50%); */}
//         }

//         .slider-controls .arrow.left {
//           position: absolute;
//           left: 20px;
//           top: 65% !important;
//         //   {/* width: 50px; */}
//           transform: translateY(-630%);
//         }

//         .slider-controls .arrow.right {
//          position: absolute;
//           right: 20px;
//           top: 65% !important;
//         //   {/* width: 50px; */}
//           transform: translateY(-630%);
//         }

//         .arrow {
//           font-size: 5em !important;
//         }

//         .slider-controls button {
//           background: none;
//           border: none;
//           font-size: 2em;
//           color: #fff;
//           cursor: pointer;
//         }

//         .dots {
//           display: flex;
//           margin: 0;
//         }

//         .dot {
//           width: 10px;
//           height: 10px;
//           background-color: #fff;
//           border-radius: 50%;
//           margin: 40px 5px;
//           cursor: pointer;
//           transition: background-color 0.3s ease;
//         }

//         .dot.active {
//           background-color: #FF3D2E;
//         }

//       `}</style>}
